import { render } from "./home.vue?vue&type=template&id=4c066c60"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"

import "./home.vue?vue&type=style&index=0&id=4c066c60&lang=css"
script.render = render

export default script